import { Predicate } from "@angular/core";
import { DigitalChecklistStatus, IDigitalChecklistAppointment, IVehicle } from "@signal/asp-data-commons";
import { DateTime } from "luxon";
import * as _ from 'lodash';
import { DeliveryChecklistState, IDigitalChecklistForm, initialDeliveryConsultant } from "./delivery-checklist.reducer";
import { extractDateAsString, userProfile } from "../../shared/services/util.service";
import { SourceOfApptChecklist, VehicleStatus } from "@signal/asp-data-commons/lib/enums/enum";


export const getFilteredApptBasedOnDeliveryTime = (appt, filter) => {
  if(filter.includes('>')) {
    const time = filter?.replace(/>/gi, '');
    return appt.filter(obj => DateTime.fromFormat(`${obj?.scheduledTime || '00:00 AM'}`, 't').toMillis() > DateTime.fromFormat(`${time} ${time.split(':')[0] === '12' ? 'PM' : 'AM'}`, 't').toMillis());
  }
  else if(filter.includes('<')) {
    const time = filter?.replace(/</gi, '');
    return appt.filter(obj => DateTime.fromFormat(`${obj?.scheduledTime || '00:00 AM'}`, 't').toMillis() < DateTime.fromFormat(`${time} ${time.split(':')[0] === '12' ? 'PM' : 'AM'}`, 't').toMillis());
  }
  else {
    const time = filter?.replace(/ /gi, '');
    return appt.filter(obj =>  DateTime.fromFormat(`${obj?.scheduledTime || '00:00 AM'}`, 't').toMillis() === DateTime.fromFormat(`${time} AM`, 't').toMillis() || 
    DateTime.fromFormat(`${obj?.scheduledTime || '00:00 AM'}`, 't').toMillis() === DateTime.fromFormat(`${time} PM`, 't').toMillis());
  }
}



export const getChecklistDateTime = (obj) => {
  const date = obj?.dateOfAcquired ? obj.dateOfAcquired : '0000-01-01';
  const time = obj?.scheduledTime ? obj.scheduledTime : '00:00 AM';
  return DateTime.fromFormat(`${date} , ${time}`, 'yyyy-MM-dd , t');
}

export const getSortedArray = (field, order, appt) => {
  switch (field) {
    case 'customerName':
      appt = _.orderBy(appt, [(obj: any) => `${obj?.customer?.firstName?.toUpperCase() || ''}${obj?.customer?.lastName?.toUpperCase() || ''}`], [order])
      break;

    case 'contactInfo':
      appt = _.orderBy(appt, [(obj: any) => obj.customer?.emailAddress?.toUpperCase()], [order])
      break;

    case 'model':
      appt = _.orderBy(appt, [(obj: any) => obj.vehicle?.model.toUpperCase()], [order])
      break;

    case 'vin':
      appt = _.orderBy(appt, [(obj: any) => obj.vehicle?.vin.toUpperCase()], [order])
      break;

    case 'deliveryTime':
      appt = _.orderBy(appt, [(obj: any) => getChecklistDateTime(obj)], [order])
      break;

    case 'deliveryDate':
      appt = _.orderBy(appt, [(obj: any) => getChecklistDateTime(obj)], [order])
      break;

    case 'advisor':
      appt = _.orderBy(appt, [(obj: any) => obj?.salesConsultant?.toUpperCase()], [order])
      break;

    case 'status':
      appt = _.orderBy(appt, [(obj: any) => obj?.status?.toUpperCase()], [order])
      break;

    case 'vehicleStatus':
      appt = _.orderBy(appt, [(obj: any) => obj?.vehicle?.dealerCategory?.toUpperCase()], [order])
      break;

    default:
      return appt
  }

  return appt;
}

export const getSortedData = (appt: IDigitalChecklistAppointment[], sortingField: string, sortOrder: string) => {
  if (sortingField?.length && sortOrder?.length && appt.length) {
    appt = getSortedArray(sortingField, sortOrder.toLowerCase(), appt);
  }
  return appt;
}

/* Footer Summary */
export function vehicleFormToSummaryProjector(vehicleForm: IVehicle) {
  /* Vehicle summary */
  const chosenVehicle = (vehicleForm.year && vehicleForm.model) ? `${vehicleForm.year} ${vehicleForm.model}` : '';
  return [{
    key: 'testDrive.vehicle',
    value: chosenVehicle
  }];
}

export function isInValidVehicle(vehicle, dealerCode) {
    if((vehicle.dealerCode !== dealerCode) || (vehicle?.dealerCategory===VehicleStatus.A) || (vehicle?.dealerCategory===VehicleStatus.F) || 
    (vehicle?.dealerCategory===VehicleStatus.G && vehicle?.dealerSubCategory && (vehicle?.dealerSubCategory!=="*" && vehicle?.dealerSubCategory!=="I" && vehicle?.dealerSubCategory!=="J")))
    {
      return true;
    }
    else {
      return false;
    }
}

/* create digital request */
export function createDigitalChecklistRequest(state: DeliveryChecklistState, isSaveForLater, dealerDetails, isVinValid): IDigitalChecklistAppointment {

  const checklistReq = { ...state.digitalChecklist };
  if(!isVinValid) {
    checklistReq.customerSignId = '';
    checklistReq.deliveryConsultant = initialDeliveryConsultant;
    checklistReq.checklistRequest = [];
  }

  const dateOfAcquired = checklistReq.dateOfAcquired ? DateTime.fromISO(extractDateAsString(checklistReq.dateOfAcquired)).toFormat('yyyy-MM-dd') : '';
  const customer = checklistReq.customerSignId ? { ...checklistReq.customer, customerSignId: checklistReq.customerSignId } :
    { ...checklistReq.customer, customerSignId: '' };
  const status = isSaveForLater ? DigitalChecklistStatus.PENDING : DigitalChecklistStatus.SUBMITTED;
  const dealer = { ...dealerDetails }
  delete dealer.service;
  if(isSaveForLater){
    delete dealer.sales;
  }
  const userProfileData = userProfile;

  delete checklistReq.customerSignId;
  if(!checklistReq?.dateOfDeletion)
  {
    delete checklistReq.dateOfDeletion;
  }
  const digiCheckReq: IDigitalChecklistAppointment = {
    ...checklistReq,
    dateOfAcquired,
    customer,
    status,
    dealer,
    checklistCreatedBy: userProfileData?.userId,
    sourceOfReq: SourceOfApptChecklist.DEL_CHKLIST_UI
  }

  return JSON.parse(JSON.stringify(digiCheckReq).replace(/null/g, '""'));
}

export function editDataPopulatedInState(checklistData: IDigitalChecklistAppointment): IDigitalChecklistForm {
  const state: IDigitalChecklistForm = {
    vehicle: { vin: null, ...checklistData.vehicle, year: String(checklistData?.vehicle?.year) },
    customer: {
      firstName: checklistData.customer?.firstName || "",
      lastName: checklistData.customer?.lastName || "",
      emailAddress: checklistData.customer?.emailAddress || "",
      phoneNumber: checklistData.customer?.phoneNumber || ""
    },
    dateOfAcquired: checklistData?.dateOfAcquired ? DateTime.fromFormat(checklistData.dateOfAcquired, 'yyyy-MM-dd').toISO() : '',
    scheduledTime: checklistData?.scheduledTime || '',
    salesConsultant: checklistData?.salesConsultant ? checklistData.salesConsultant : '',
    checklistRequest: checklistData.checklistRequest ? checklistData.checklistRequest : [],
    deliveryConsultant: checklistData?.deliveryConsultant,
    customerSignId: checklistData.customer?.customerSignId ? checklistData.customer.customerSignId : '',
    descriptionOfProductsOrServices: checklistData?.descriptionOfProductsOrServices || '',
    dateOfDeletion:checklistData?.dateOfDeletion || ''
  };

  return state;
}

export function updateDigitalChecklistRequest(state: DeliveryChecklistState, isSaveForLater, dealer, isVinValid): IDigitalChecklistAppointment {
  const updateReq = createDigitalChecklistRequest(state, isSaveForLater, dealer, isVinValid);
  updateReq.digichkId = state.editDetails.digiChekId;
  return updateReq;
}

